import { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import MobileBottomNav from '../../components/feature/MobileBottomNav';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import { featuredProducts, productReviews } from '../../mocks/products';

const COLOR_OPTIONS = [
  { label: 'Altın Sarısı', value: '#D4A017', bg: 'bg-[#D4A017]' },
  { label: 'Gümüş', value: '#A8A9AD', bg: 'bg-[#A8A9AD]' },
  { label: 'Beyaz', value: '#FFFFFF', bg: 'bg-white border border-gray-300' },
  { label: 'Siyah', value: '#1A1A1A', bg: 'bg-[#1A1A1A]' },
  { label: 'Pembe', value: '#F472B6', bg: 'bg-pink-400' },
  { label: 'Kırmızı', value: '#EF4444', bg: 'bg-red-500' },
  { label: 'Yeşil', value: '#22C55E', bg: 'bg-green-500' },
  { label: 'Turuncu', value: '#F97316', bg: 'bg-orange-500' },
  { label: 'Bej', value: '#D4B896', bg: 'bg-[#D4B896]' },
  { label: 'Lacivert', value: '#1E3A5F', bg: 'bg-[#1E3A5F]' },
];

const FRAME_COLOR_OPTIONS = [
  { label: 'Doğal Ahşap', value: 'Doğal Ahşap', bg: 'bg-[#C19A6B]' },
  { label: 'Beyaz', value: 'Beyaz', bg: 'bg-white border border-gray-300' },
  { label: 'Siyah', value: 'Siyah', bg: 'bg-[#1A1A1A]' },
  { label: 'Altın', value: 'Altın', bg: 'bg-[#D4A017]' },
  { label: 'Gümüş', value: 'Gümüş', bg: 'bg-[#A8A9AD]' },
  { label: 'Pembe', value: 'Pembe', bg: 'bg-pink-300' },
  { label: 'Krem', value: 'Krem', bg: 'bg-[#F5F0E8]' },
];

const FLOWER_COLOR_OPTIONS = [
  { label: 'Pembe', value: 'Pembe', bg: 'bg-pink-300' },
  { label: 'Kırmızı', value: 'Kırmızı', bg: 'bg-red-500' },
  { label: 'Beyaz', value: 'Beyaz', bg: 'bg-white border border-gray-300' },
  { label: 'Sarı', value: 'Sarı', bg: 'bg-yellow-400' },
  { label: 'Mor', value: 'Mor', bg: 'bg-violet-400' },
  { label: 'Turuncu', value: 'Turuncu', bg: 'bg-orange-400' },
  { label: 'Lila', value: 'Lila', bg: 'bg-purple-300' },
  { label: 'Somon', value: 'Somon', bg: 'bg-[#FA8072]' },
];

const VASE_COLOR_OPTIONS = [
  { label: 'Altın', value: 'Altın', bg: 'bg-[#D4A017]' },
  { label: 'Gümüş', value: 'Gümüş', bg: 'bg-[#A8A9AD]' },
  { label: 'Beyaz', value: 'Beyaz', bg: 'bg-white border border-gray-300' },
  { label: 'Siyah', value: 'Siyah', bg: 'bg-[#1A1A1A]' },
  { label: 'Krem', value: 'Krem', bg: 'bg-[#F5F0E8]' },
  { label: 'Bakır', value: 'Bakır', bg: 'bg-[#B87333]' },
  { label: 'Pembe', value: 'Pembe', bg: 'bg-pink-300' },
  { label: 'Turkuaz', value: 'Turkuaz', bg: 'bg-teal-400' },
];

export default function UrunDetay() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const product = featuredProducts.find((p) => p.slug === slug);

  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [addedToCart, setAddedToCart] = useState(false);
  const [activeTab, setActiveTab] = useState<'aciklama' | 'ozellikler' | 'yorumlar'>('aciklama');

  const [customText, setCustomText] = useState('');
  const [customNote, setCustomNote] = useState('');
  const [selectedTextColor, setSelectedTextColor] = useState(COLOR_OPTIONS[0].value);
  const [selectedFrameColor, setSelectedFrameColor] = useState(FRAME_COLOR_OPTIONS[0].value);
  const [selectedFlowerColor, setSelectedFlowerColor] = useState(FLOWER_COLOR_OPTIONS[0].value);
  const [selectedVaseColor, setSelectedVaseColor] = useState(VASE_COLOR_OPTIONS[0].value);
  const [textColorTooltip, setTextColorTooltip] = useState('');
  const [frameColorTooltip, setFrameColorTooltip] = useState('');
  const [flowerColorTooltip, setFlowerColorTooltip] = useState('');
  const [vaseColorTooltip, setVaseColorTooltip] = useState('');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setCustomText('');
    setCustomNote('');
    setSelectedTextColor(COLOR_OPTIONS[0].value);
    setSelectedFrameColor(FRAME_COLOR_OPTIONS[0].value);
    setSelectedFlowerColor(FLOWER_COLOR_OPTIONS[0].value);
    setSelectedVaseColor(VASE_COLOR_OPTIONS[0].value);
  }, [slug]);

  if (!product) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <Navbar />
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Ürün bulunamadı</h2>
          <Link to="/kategoriler" className="text-pink-500 hover:underline">Tüm ürünlere dön</Link>
        </div>
        <MobileBottomNav />
      </div>
    );
  }

  const reviews = productReviews[product.id] || [];
  const relatedProducts = featuredProducts
    .filter((p) => p.category === product.category && p.id !== product.id)
    .slice(0, 4);

  const handleAddToCart = () => {
    const cart = JSON.parse(localStorage.getItem('cart') || '[]');
    const customization = {
      text: customText,
      note: customNote,
      textColor: selectedTextColor,
      frameColor: selectedFrameColor,
      flowerColor: selectedFlowerColor,
      vaseColor: selectedVaseColor,
    };
    const existingItem = cart.find(
      (item: { id: number; customization?: typeof customization }) =>
        item.id === product.id &&
        JSON.stringify(item.customization) === JSON.stringify(customization)
    );
    if (existingItem) {
      existingItem.quantity += quantity;
    } else {
      cart.push({ ...product, quantity, customization });
    }
    localStorage.setItem('cart', JSON.stringify(cart));
    window.dispatchEvent(new Event('cartUpdated'));
    setAddedToCart(true);
    setTimeout(() => setAddedToCart(false), 2500);
  };

  const handleBuyNow = () => {
    handleAddToCart();
    navigate('/sepet');
  };

  const whatsappMessage = encodeURIComponent(
    `Merhaba! "${product.name}" ürünü hakkında bilgi almak istiyorum.${customText ? ` Yazı: "${customText}"` : ''}${selectedTextColor ? ` Yazı rengi: ${COLOR_OPTIONS.find(c => c.value === selectedTextColor)?.label}` : ''} Çiçek rengi: ${selectedFlowerColor}. Vazo rengi: ${selectedVaseColor}. Çerçeve rengi: ${selectedFrameColor}.${customNote ? ` Not: ${customNote}` : ''}`
  );

  const renderStars = (rating: number) =>
    Array.from({ length: 5 }).map((_, i) => (
      <i
        key={i}
        className={`${i < Math.round(rating) ? 'ri-star-fill' : 'ri-star-line'} text-amber-400`}
      />
    ));

  return (
    <div className="min-h-screen bg-[#fafaf8] font-['Inter',sans-serif]">
      <Navbar />
      <WhatsAppButton />

      {/* Breadcrumb */}
      <div className="pt-24 pb-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center gap-1.5 text-xs text-gray-400">
            <Link to="/" className="hover:text-orange-500 transition-colors cursor-pointer font-medium">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line text-gray-300"></i>
            <Link to="/kategoriler" className="hover:text-orange-500 transition-colors cursor-pointer font-medium">Kategoriler</Link>
            <i className="ri-arrow-right-s-line text-gray-300"></i>
            <span className="text-gray-700 font-semibold">{product.name}</span>
          </nav>
        </div>
      </div>

      {/* Main Product Section */}
      <section className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">

            {/* Image Gallery */}
            <div className="space-y-3">
              <div className="relative w-full h-[520px] bg-[#f5f3ef] rounded-2xl overflow-hidden flex items-center justify-center">
                {product.discount > 0 && (
                  <span className="absolute top-5 left-5 z-10 bg-red-500 text-white text-xs font-bold px-3 py-1.5 rounded-md">
                    %{product.discount} İNDİRİM
                  </span>
                )}
                <img
                  src={product.images[selectedImage]}
                  alt={product.name}
                  className="w-full h-full object-contain transition-all duration-500"
                />
              </div>
              <div className="grid grid-cols-4 gap-2">
                {product.images.map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setSelectedImage(idx)}
                    className={`w-full rounded-xl overflow-hidden border-2 transition-all cursor-pointer flex items-center justify-center bg-[#f5f3ef] ${
                      selectedImage === idx ? 'border-orange-500' : 'border-transparent hover:border-orange-300'
                    }`}
                    style={{ height: '88px' }}
                  >
                    <img src={img} alt={`${product.name} ${idx + 1}`} className="w-full h-full object-contain p-2" />
                  </button>
                ))}
              </div>
            </div>

            {/* Product Info */}
            <div className="space-y-5">
              <div>
                <div className="flex flex-wrap items-center gap-2 mb-3">
                  <span className="inline-block text-[10px] font-bold text-orange-500 bg-orange-50 px-3 py-1 rounded-full uppercase tracking-widest">
                    {product.category}
                  </span>
                </div>
                <h1 className="text-3xl md:text-4xl font-black font-['Playfair_Display'] text-gray-900 leading-tight mb-2">
                  {product.name}
                </h1>
              </div>

              {/* Rating */}
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-0.5">
                  {renderStars(product.rating)}
                </div>
                <span className="text-sm font-bold text-gray-800">{product.rating}</span>
                <span className="text-sm text-gray-400">({product.reviewCount} değerlendirme)</span>
              </div>

              {/* Price */}
              <div className="flex items-end gap-3 flex-wrap">
                <span className="text-4xl font-bold text-gray-900">{product.price.toLocaleString('tr-TR')} ₺</span>
                {product.oldPrice > 0 && (
                  <span className="text-xl text-gray-400 line-through mb-1">{product.oldPrice.toLocaleString('tr-TR')} ₺</span>
                )}
                {product.discount > 0 && (
                  <span className="text-xs font-bold text-green-600 bg-green-50 px-2 py-1 rounded-md mb-1">
                    {(product.oldPrice - product.price).toLocaleString('tr-TR')} ₺ Tasarruf
                  </span>
                )}
              </div>

              {/* Stock */}
              <div className="flex items-center gap-2">
                <div className={`w-2 h-2 rounded-full ${product.stock > 5 ? 'bg-green-500' : 'bg-yellow-400'}`}></div>
                <span className={`text-xs font-semibold ${product.stock > 5 ? 'text-green-600' : 'text-yellow-600'}`}>
                  {product.stock > 5 ? 'Stokta mevcut' : `Son ${product.stock} adet!`}
                </span>
              </div>

              <div className="border-t border-gray-100"></div>

              {/* ===== KİŞİSELLEŞTİRME BÖLÜMÜ ===== */}
              <div className="bg-orange-50/60 rounded-2xl p-5 space-y-5 border border-orange-100">
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-magic-line text-orange-500 text-lg"></i>
                  </div>
                  <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wide">Kişiselleştirme</h3>
                  <span className="text-[10px] text-orange-500 font-bold bg-orange-100 px-2 py-0.5 rounded-full uppercase">Zorunlu</span>
                </div>

                {/* Yazı İçeriği */}
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wide">
                    Yazı İçeriği
                    <span className="text-gray-400 font-normal normal-case ml-1">(isim, tarih veya mesaj)</span>
                  </label>
                  <input
                    type="text"
                    value={customText}
                    onChange={(e) => setCustomText(e.target.value)}
                    placeholder="Örn: Çelik Ailesi, 15.03.2024..."
                    maxLength={60}
                    className="w-full px-4 py-3 rounded-xl border border-orange-200 bg-white text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-orange-400 transition-colors"
                  />
                  <p className="text-xs text-gray-400 text-right">{customText.length}/60</p>
                </div>

                {/* Yazı Rengi */}
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wide">Yazı Rengi</label>
                  <div className="flex flex-wrap gap-2">
                    {COLOR_OPTIONS.map((color) => (
                      <div key={color.value} className="relative">
                        <button
                          onClick={() => setSelectedTextColor(color.value)}
                          onMouseEnter={() => setTextColorTooltip(color.value)}
                          onMouseLeave={() => setTextColorTooltip('')}
                          title={color.label}
                          className={`w-7 h-7 rounded-full ${color.bg} transition-all cursor-pointer flex items-center justify-center ${
                            selectedTextColor === color.value
                              ? 'ring-2 ring-offset-2 ring-orange-500 scale-110'
                              : 'hover:scale-105'
                          }`}
                        >
                          {selectedTextColor === color.value && (
                            <i className={`ri-check-line text-xs font-bold ${color.value === '#FFFFFF' || color.value === '#F5F0E8' || color.value === '#D4B896' ? 'text-gray-700' : 'text-white'}`}></i>
                          )}
                        </button>
                        {textColorTooltip === color.value && (
                          <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded-lg whitespace-nowrap z-10">
                            {color.label}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500">Seçili: <span className="font-semibold text-gray-700">{COLOR_OPTIONS.find(c => c.value === selectedTextColor)?.label}</span></p>
                </div>

                {/* Çiçek Rengi */}
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wide">Çiçek Rengi</label>
                  <div className="flex flex-wrap gap-2">
                    {FLOWER_COLOR_OPTIONS.map((color) => (
                      <div key={color.value} className="relative">
                        <button
                          onClick={() => setSelectedFlowerColor(color.value)}
                          onMouseEnter={() => setFlowerColorTooltip(color.value)}
                          onMouseLeave={() => setFlowerColorTooltip('')}
                          title={color.label}
                          className={`w-7 h-7 rounded-full ${color.bg} transition-all cursor-pointer flex items-center justify-center ${
                            selectedFlowerColor === color.value
                              ? 'ring-2 ring-offset-2 ring-orange-500 scale-110'
                              : 'hover:scale-105'
                          }`}
                        >
                          {selectedFlowerColor === color.value && (
                            <i className={`ri-check-line text-xs font-bold ${color.value === 'Beyaz' || color.value === 'Sarı' ? 'text-gray-700' : 'text-white'}`}></i>
                          )}
                        </button>
                        {flowerColorTooltip === color.value && (
                          <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded-lg whitespace-nowrap z-10">
                            {color.label}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500">Seçili: <span className="font-semibold text-gray-700">{selectedFlowerColor}</span></p>
                </div>

                {/* Vazo Rengi */}
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wide">Vazo Rengi</label>
                  <div className="flex flex-wrap gap-2">
                    {VASE_COLOR_OPTIONS.map((color) => (
                      <div key={color.value} className="relative">
                        <button
                          onClick={() => setSelectedVaseColor(color.value)}
                          onMouseEnter={() => setVaseColorTooltip(color.value)}
                          onMouseLeave={() => setVaseColorTooltip('')}
                          title={color.label}
                          className={`w-7 h-7 rounded-full ${color.bg} transition-all cursor-pointer flex items-center justify-center ${
                            selectedVaseColor === color.value
                              ? 'ring-2 ring-offset-2 ring-orange-500 scale-110'
                              : 'hover:scale-105'
                          }`}
                        >
                          {selectedVaseColor === color.value && (
                            <i className={`ri-check-line text-xs font-bold ${color.value === 'Beyaz' || color.value === 'Krem' ? 'text-gray-700' : 'text-white'}`}></i>
                          )}
                        </button>
                        {vaseColorTooltip === color.value && (
                          <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded-lg whitespace-nowrap z-10">
                            {color.label}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500">Seçili: <span className="font-semibold text-gray-700">{selectedVaseColor}</span></p>
                </div>

                {/* Çerçeve Rengi */}
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wide">Çerçeve / Zemin Rengi</label>
                  <div className="flex flex-wrap gap-2">
                    {FRAME_COLOR_OPTIONS.map((color) => (
                      <div key={color.value} className="relative">
                        <button
                          onClick={() => setSelectedFrameColor(color.value)}
                          onMouseEnter={() => setFrameColorTooltip(color.value)}
                          onMouseLeave={() => setFrameColorTooltip('')}
                          title={color.label}
                          className={`w-7 h-7 rounded-full ${color.bg} transition-all cursor-pointer flex items-center justify-center ${
                            selectedFrameColor === color.value
                              ? 'ring-2 ring-offset-2 ring-orange-500 scale-110'
                              : 'hover:scale-105'
                          }`}
                        >
                          {selectedFrameColor === color.value && (
                            <i className={`ri-check-line text-xs font-bold ${color.value === 'Beyaz' || color.value === 'Krem' ? 'text-gray-700' : 'text-white'}`}></i>
                          )}
                        </button>
                        {frameColorTooltip === color.value && (
                          <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded-lg whitespace-nowrap z-10">
                            {color.label}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500">Seçili: <span className="font-semibold text-gray-700">{selectedFrameColor}</span></p>
                </div>

                {/* Ek Not */}
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wide">
                    Ek Not <span className="text-gray-400 font-normal normal-case">(isteğe bağlı)</span>
                  </label>
                  <textarea
                    value={customNote}
                    onChange={(e) => setCustomNote(e.target.value.slice(0, 200))}
                    placeholder="Tasarımla ilgili özel isteklerinizi yazın..."
                    rows={3}
                    maxLength={200}
                    className="w-full px-4 py-3 rounded-xl border border-orange-200 bg-white text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-orange-400 transition-colors resize-none"
                  />
                  <p className="text-xs text-gray-400 text-right">{customNote.length}/200</p>
                </div>

                {/* Özet */}
                <div className="bg-white rounded-xl p-3 border border-orange-200">
                  <p className="text-[10px] text-gray-500 mb-2 font-bold uppercase tracking-wide">Sipariş Özeti</p>
                  <div className="flex flex-wrap gap-1.5 text-xs">
                    {customText && <span className="bg-orange-50 text-orange-700 px-2 py-1 rounded-lg"><strong>Yazı:</strong> {customText}</span>}
                    <span className="bg-orange-50 text-orange-700 px-2 py-1 rounded-lg"><strong>Yazı Rengi:</strong> {COLOR_OPTIONS.find(c => c.value === selectedTextColor)?.label}</span>
                    <span className="bg-orange-50 text-orange-700 px-2 py-1 rounded-lg"><strong>Çiçek:</strong> {selectedFlowerColor}</span>
                    <span className="bg-orange-50 text-orange-700 px-2 py-1 rounded-lg"><strong>Vazo:</strong> {selectedVaseColor}</span>
                    <span className="bg-orange-50 text-orange-700 px-2 py-1 rounded-lg"><strong>Çerçeve:</strong> {selectedFrameColor}</span>
                  </div>
                </div>
              </div>
              {/* ===== KİŞİSELLEŞTİRME SONU ===== */}

              {/* Quantity */}
              <div className="flex items-center gap-4">
                <span className="text-xs font-bold text-gray-700 uppercase tracking-wide">Adet:</span>
                <div className="flex items-center border border-gray-200 rounded-lg overflow-hidden bg-white">
                  <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="w-10 h-10 flex items-center justify-center text-gray-600 hover:bg-gray-50 transition-colors cursor-pointer">
                    <i className="ri-subtract-line"></i>
                  </button>
                  <span className="w-10 text-center text-sm font-bold text-gray-900">{quantity}</span>
                  <button onClick={() => setQuantity(Math.min(product.stock, quantity + 1))} className="w-10 h-10 flex items-center justify-center text-gray-600 hover:bg-gray-50 transition-colors cursor-pointer">
                    <i className="ri-add-line"></i>
                  </button>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={handleAddToCart}
                  className={`flex-1 py-4 rounded-xl font-bold text-sm transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer ${
                    addedToCart
                      ? 'bg-green-500 text-white'
                      : 'bg-white border-2 border-gray-900 text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  <i className={addedToCart ? 'ri-check-line' : 'ri-shopping-cart-line'}></i>
                  <span>{addedToCart ? 'Sepete Eklendi!' : 'Sepete Ekle'}</span>
                </button>
                <button
                  onClick={handleBuyNow}
                  className="flex-1 py-4 bg-gray-900 hover:bg-gray-800 text-white rounded-xl font-bold text-sm transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-flashlight-line text-orange-400"></i>
                  <span>Hemen Satın Al</span>
                </button>
              </div>

              {/* WhatsApp */}
              <a
                href={`https://wa.me/905551234567?text=${whatsappMessage}`}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center justify-center gap-2 py-3.5 rounded-xl border border-green-200 text-green-700 bg-green-50 hover:bg-green-100 transition-colors font-semibold text-sm cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-lg text-green-600"></i>
                <span>WhatsApp ile Sor</span>
              </a>

              <div className="border-t border-gray-100"></div>

              {/* Delivery Info */}
              <div className="grid grid-cols-3 gap-2">
                {[
                  { icon: 'ri-truck-line', text: product.deliveryInfo },
                  { icon: 'ri-shield-check-line', text: 'Güvenli Ödeme' },
                  { icon: 'ri-gift-2-line', text: 'Hediye Paketi' },
                ].map((f, i) => (
                  <div key={i} className="text-center p-3 bg-white rounded-xl border border-gray-100">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto mb-1.5">
                      <i className={`${f.icon} text-xl text-orange-500`}></i>
                    </div>
                    <p className="text-xs text-gray-600 font-medium leading-tight">{f.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tabs */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex gap-1 p-1 bg-gray-100 rounded-xl w-fit mb-8">
            {(['aciklama', 'ozellikler', 'yorumlar'] as const).map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-6 py-2.5 rounded-lg text-xs font-bold transition-all whitespace-nowrap cursor-pointer uppercase tracking-wide ${
                  activeTab === tab ? 'bg-white text-gray-900' : 'text-gray-400 hover:text-gray-600'
                }`}
              >
                {tab === 'aciklama' && 'Açıklama'}
                {tab === 'ozellikler' && 'Özellikler'}
                {tab === 'yorumlar' && `Yorumlar (${reviews.length})`}
              </button>
            ))}
          </div>

          {activeTab === 'aciklama' && (
            <div className="max-w-3xl bg-white rounded-2xl p-8 border border-gray-100">
              <p className="text-gray-600 leading-relaxed text-sm">{product.description}</p>
            </div>
          )}

          {activeTab === 'ozellikler' && (
            <div className="max-w-3xl bg-white rounded-2xl p-8 border border-gray-100">
              <ul className="space-y-3">
                {product.features.map((feat, i) => (
                  <li key={i} className="flex items-center gap-3 text-sm text-gray-700">
                    <div className="w-5 h-5 flex items-center justify-center shrink-0">
                      <i className="ri-checkbox-circle-fill text-orange-500 text-lg"></i>
                    </div>
                    <span>{feat}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {activeTab === 'yorumlar' && (
            <div className="max-w-3xl space-y-4">
              {reviews.length === 0 ? (
                <div className="bg-white rounded-2xl p-8 text-center text-gray-400 text-sm border border-gray-100">
                  Henüz yorum yapılmamış. İlk yorumu siz yapın!
                </div>
              ) : (
                reviews.map((review, i) => (
                  <div key={i} className="bg-white rounded-2xl p-6 flex gap-4 border border-gray-100">
                    <div className="w-10 h-10 flex-shrink-0 rounded-full overflow-hidden">
                      <img src={review.avatar} alt={review.name} className="w-full h-full object-cover" />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-1">
                        <span className="font-bold text-gray-900 text-sm">{review.name}</span>
                        <span className="text-xs text-gray-400">{review.date}</span>
                      </div>
                      <div className="flex items-center gap-0.5 mb-2">
                        {renderStars(review.rating)}
                      </div>
                      <p className="text-sm text-gray-600 leading-relaxed">{review.comment}</p>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </section>

      {/* Related Products */}
      {relatedProducts.length > 0 && (
        <section className="py-12 bg-[#faf9f7]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mb-8">
              <p className="text-orange-500 text-xs font-bold tracking-[0.3em] uppercase mb-1">Keşfet</p>
              <h2 className="text-2xl font-black font-['Playfair_Display'] text-gray-900">
                BENZER ÜRÜNLER
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
              {relatedProducts.map((p) => (
                <Link
                  to={`/urun/${p.slug}`}
                  key={p.id}
                  className="group bg-white rounded-xl overflow-hidden border border-gray-100 hover:border-gray-200 transition-all cursor-pointer block"
                >
                  <div className="relative bg-[#f7f5f2] overflow-hidden" style={{ paddingBottom: '100%' }}>
                    {p.discount > 0 && (
                      <span className="absolute top-3 left-3 z-10 bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-md">
                        %{p.discount}
                      </span>
                    )}
                    <img
                      src={p.image}
                      alt={p.name}
                      className="absolute inset-0 w-full h-full object-contain p-3 group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4">
                    <p className="text-[10px] text-orange-500 font-bold uppercase tracking-widest mb-1.5">{p.category}</p>
                    <h3 className="text-sm font-semibold text-gray-900 line-clamp-2 mb-2 leading-snug">{p.name}</h3>
                    <div className="flex items-baseline gap-2">
                      <span className="text-base font-bold text-gray-900">{p.price.toLocaleString('tr-TR')} ₺</span>
                      {p.oldPrice > 0 && (
                        <span className="text-xs text-gray-400 line-through">{p.oldPrice.toLocaleString('tr-TR')} ₺</span>
                      )}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      <Footer />
      <MobileBottomNav />
    </div>
  );
}
